<template>
    <div class="container">
        <div class="row">
            <div class="col-12" style="margin-top: 40px; font-size: 20px; text-align: center;">{{ this.$route.query.name }} —— 添加题解视频页面</div>
            <div>一个题目只对应一个题解视频！！！</div>
            <div class="col-12" style="margin-top: 20px;">
                <div v-show="this.error_message !== ''" style="color: red; font-size: 20px; font-weight: 600; text-align: center;">error_meesage: {{ error_message }}</div>
                <input type="file" ref="fileInput">
                <div ref="progressDiv"></div>
                <button @click="handleUpload">传给后端</button>
                <el-input
                    style="margin:3px;"
                    placeholder="请输入课程路径名称"
                    v-model="urlName"
                    clearable>
                </el-input>
                <el-input
                    style="margin:3px;"
                    placeholder="请输入视频标题"
                    v-model="videoName"
                    clearable>
                </el-input>
                <el-button type="text" style="font-size: 20px;" @click="CreateVideo">添加课程视频</el-button>
                <el-button type="text" style="margin-left:30px; font-size: 20px; color: red;" @click="DeleteVideo">删除课程视频</el-button>
            </div>
        </div>
    </div>
  </template>
  
  <script>
    import $ from 'jquery'
    import { uploadFile } from '../Course/vid-upload'
    import Url from '@/constant/Url'
  
    export default {
      name:'QuestionVideo',
      data() {
        return {
          id:'',
          videoName:'',
          urlName:'',
          error_message:'',
  
          list:[],
        }
      },
      mounted() {
        this.ReadVideo()
      },
      methods: {
        DeleteVideo() { // 删除视频
          const vue = this
          const store = this.$store
  
          $.ajax({
            url: Url.dProblemVideoUrl,
            type:'post',
            headers: {
              Authorization: "Bearer " + store.state.me.token,
            },
            data: {
              id: vue.id,
            },
            success(resp) {
              if (resp.error_message === "success") {
                vue.error_message = "删除题解视频成功了"
                vue.ReadVideo()
              } else {
                vue.error_message = resp.error_message
              }
            },
            error(resp) {
              console.log("删除课程视频彻底失败了, resp == >", resp)
            }
          })
        },
        CreateVideo() { // 创建课程页面
            // console.log("url == >", Url.cCourseVideoUrl)
            const vue = this
            const store = this.$store
            const route = this.$route

            $.ajax({
              url: Url.cProblemVideoUrl,
              type:'post',
              headers: {
                Authorization: "Bearer " + store.state.me.token,
              },
              data: {
                pbid: route.query.pbid,
                url: vue.urlName,
                videoName: vue.videoName,
              },
              success(resp) {
                if (resp.error_message === "success") {
                  vue.error_message = "success"
                  vue.ReadVideo()
                } else {
                  vue.error_message = resp.error_message
                }
              },
              error(resp) {
                console.log("创建题目题解视频彻底失败了, resp == >", resp)
              }
            })
        },
        ReadVideo() { // 获取课程视频
          const vue = this
          const store = this.$store
          const route = this.$route
          
          $.ajax({
            url: Url.rProblemVideoUrl,
            type:'post',
            headers: {
              Authorization: "Bearer " + store.state.me.token,
            },
            data: {
              pbid: route.query.pbid, // 目录id
            },
            success(resp) {
              if (resp.error_message === "success") {
                vue.error_message = "题解视频获取成功"
                const list = JSON.parse(resp.list)
                console.log("list == > ", list)
                vue.videoName = list.videoName
                vue.urlName = list.url
                vue.id = list.id
              } else {
                vue.error_message = resp.error_message
                vue.videoName = ""
                vue.urlName = ""
                vue.id = ""
              }
            },
            error(resp) {
              console.log("获取课程视频彻底失败了, resp == >", resp)
            }
          })
        },
        handleUpload() {
          const fileInput = this.$refs.fileInput;
          console.log("fileInput", fileInput.files[0])
          const progressDiv = this.$refs.progressDiv;
          let classname = this.urlName;
          if (classname === undefined || classname === "") {
            this.error_message = "请先保证urlName不为空"
            return
          }
          this.error_message = "上传视频成功了"
          const file = fileInput.files[0];
          uploadFile(file, progressDiv, classname);
        },
      },
    };
  </script>
  
  <style scoped>
  
  </style>
  